import { CellProps } from 'react-table';
import { ExaminationType } from '@higo/api';
import { ExaminationTypeLabeledIcon, RoundQuickCheckIcon } from '@higo/ui';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

const TypeWithIcon = styled('span')(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1.5rem 1fr;
    grid-column-gap: 0.5rem;
    align-items: center;
    color: ${theme.palette.secondary['500']};

    & > span {
      color: ${theme.palette.secondary['900']};
      ${theme.typography.subtitle1}
    }
  `,
);

export const ExamTypeCellRenderer = <T extends Record<string, unknown>>({
  cell,
}: CellProps<T, ExaminationType | 'VISIT'>) => {
  if (cell.value === 'VISIT') {
    return (
      <TypeWithIcon>
        <RoundQuickCheckIcon size="1.5rem" />
        <span>
          <FormattedMessage id="common.visit" />
        </span>
      </TypeWithIcon>
    );
  }

  return (
    <ExaminationTypeLabeledIcon
      examinationType={cell.value as ExaminationType}
      icon={<RoundQuickCheckIcon />}
    />
  );
};
